<template>
  <div class="devOps_producerSpaceReportWeekly" >
    <el-form ref="form" class="form_warp" inline size="mini" :model="form" label-width="100px">
      <el-form-item label="项目"  label-width="auto">
        <el-select v-model="form.project_ids"  collapse-tags  placeholder="请选择项目" multiple  @change="selectAll($event)"  filterable>
          <el-option v-for="(value, key) in options" :key="key" :label="value" :value="key" />
        </el-select>
      </el-form-item>
      <el-form-item label="开始日期" prop="startDate" label-width="80px">
        <el-date-picker @change="endTimeHandle('start')" value-format="yyyy-MM-dd"  :clearable = "false" v-model="form.startDate" type="date" placeholder="选择开始日期" />
      </el-form-item>
      <el-form-item label="结束日期" prop="endDate" label-width="80px">
        <el-date-picker @change="endTimeHandle('end')" value-format="yyyy-MM-dd" :clearable = "false" v-model="form.endDate"  type="date" placeholder="选择结束日期"  />
      </el-form-item>
      <el-form-item>
        <el-button  type="primary" @click.stop="formSearch('reset','search',true)">查询</el-button>
        <el-button  @click.stop="resetForm">重置</el-button>
      </el-form-item>
      <div style="margin: 10px;">
        <el-button @click="searchTime(1)" size="mini">过去一个月</el-button>
        <el-button @click="searchTime(2)" size="mini">过去二个月</el-button>
        <!-- <el-button @click="searchTime(6)" size="mini">过去半年</el-button> -->
      </div>
    </el-form>
    <div v-loading="loading">
      <el-table
        :data="tableData"
        :header-cell-style="getCellClass"
        size="mini"
        row-key="id"
        max-height="600"
        style="width: 100%"
      >
        <el-table-column prop="project_name" label="项目名称"/>
        <el-table-column prop="name" label=""/>
        <el-table-column prop="project_total_lines_added" label="项目添加的代码行数"/>
        <el-table-column prop="project_total_lines_deletions" label="项目删除的代码行数"/>
        <el-table-column prop="project_total_lines_total" label="项目修改的代码行数"/>
      </el-table>
    </div>
  </div>
</template>
<script>
import { getDevopsPerformance } from "@/server/tops/devOps";
import { getLastMonthStartAndEnd, generateUniqueId } from "@/untils/currentTime"
export default {
  data() {
    return {
      loading:false,
      tableData:[],
      // 表单搜索条件
      form: {
        startDate: '',
        endDate: '',
        projectId:'',
        project_ids: [],
      },
      options:{},
      currentEndTime:'',
      currentsSartTime:'',
    };
  },
  async created() {
    let {startTime,endTime}= getLastMonthStartAndEnd(1)
    this.currentEndTime=endTime
    this.currentsSartTime=startTime
    this.form.startDate=endTime
    this.form.endDate=startTime
    this.options=JSON.parse(localStorage.getItem("GITLABPATAM"))
    await this.formSearch()
  },
 getCurrentTime(){
    let {startTime,endTime}= getLastMonthStartAndEnd(1)
    this.form.startDate=endTime
    this.form.endDate=startTime
  },
  methods: {
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:36px;background:#7F7F7F;color:#FFFFFF;font-size:14px;"
    },
    endTimeHandle(type){
      let start=(new Date(this.form.startDate)).getTime()
      let end=(new Date(this.form.endDate)).getTime()
      if(type==='end'&&start>end){
        this.form.endDate=''
        this.$notify({
            message: "结束时间不能小于开始时间",
            type: "error",
        })
      }else if(type==='start'&&start>end){
        this.form.startDate=''
        this.$notify({
            message: "开始时间不能大于结束时间",
            type: "error",
        })
      }
    },
    searchTime(index){
      let {startTime,endTime}= getLastMonthStartAndEnd(index)
      this.form.startDate=endTime
      this.form.endDate=startTime
      this.formSearch()
    },
  async  resetForm() {
      Object.keys(this.form).forEach((e) => {
        this.form[e] = "";
      });
      this.form.startDate=this.currentEndTime
      this.form.endDate=this.currentsSartTime
      this.form.project_ids = [];
      await this.formSearch();
    },
    // 表单搜索
    async formSearch() {
      let start=(new Date(this.form.startDate)).getTime()
      let end=(new Date(this.form.endDate)).getTime()
      if(start>end){
        this.$notify({
            message: "结束时间不能小于开始时间",
            type: "error",
        })
        return false
      }
      this.tableData=[]
      try {
        let params = {
          project_ids: this.form.project_ids.join(','),
          startDate: this.form.startDate,
          endDate: this.form.endDate,
        };
        
        this.loading=true
        let res=await getDevopsPerformance(params)
        if (res.status == 'success') {
          this.loading=false
          res.data.forEach((item,i)=>{
            if((JSON.stringify(item.data_detail))!=='{}'){
              this.tableData.push({
                data_detail:item.data_detail,
                id: generateUniqueId(),
                project_name:item.project_name,
                name:'',
                project_total_lines_added:item.project_total_lines_added,
                project_total_lines_deletions:item.project_total_lines_deletions,
                project_total_lines_total:item.project_total_lines_total,
                children:[
                    {
                    id:generateUniqueId(),
                    project_name:'',
                    name:'姓名',
                    project_total_lines_added:'本人添加的代码行数',
                    project_total_lines_deletions:'本人删除的代码行数',
                    project_total_lines_total:'本人修改的代码行数',
                  }
                ]
              })
            }
          })
          this.tableData.forEach((item,index)=>{
            let str=Object.keys(item.data_detail)
            let str1=item.data_detail
              str&&str.forEach((m,i)=>{
                item.children.push(
                  {
                    id: generateUniqueId(),
                    project_name:'',
                    name:m,
                    project_total_lines_added:str1[m].total_lines_added,
                    project_total_lines_deletions:str1[m].total_lines_deletions,
                    project_total_lines_total:str1[m].total_lines_total,
                  }
                )
              })
          })
        }
      } catch (error) {
        this.loading=false
      }
    },

    selectAll(m) {
        this.form.project_ids = m
    },
  },
};
</script>
<style lang="scss">

</style>
